import AnticipoVinculacion from './AnticipoVinculacion'

const AnticipoSueldo = props => (
  <AnticipoVinculacion
    {...props}
    type={props.type || 'egreso'}
    title='Anticipo Sueldo'
    slug='anticipo-sueldo'
    counterpartyLabel='Mes remuneraciones'
    amountLabel='Monto Anticipo Sueldo'
    classification='1-1-6-1 Anticipo Sueldo'
    showRut={false}
  />
)

export default AnticipoSueldo
